export default __webpack_public_path__ + "c40d598f5665dfa2b91ab98c7477e409.png";